var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipLocIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.714A1.72 1.72 0 009.214 12 1.72 1.72 0 007.5 10.286 1.72 1.72 0 005.785 12 1.72 1.72 0 007.5 13.714zM12.643 6h-.858V4.286C11.785 1.886 9.9 0 7.5 0a4.244 4.244 0 00-4.286 4.286h1.629A2.67 2.67 0 017.5 1.629a2.67 2.67 0 012.657 2.657V6h-7.8A1.72 1.72 0 00.643 7.714v8.572A1.72 1.72 0 002.357 18h10.286a1.72 1.72 0 001.714-1.714V7.714A1.72 1.72 0 0012.643 6zm0 10.286H2.357V7.714h10.286v8.572z",
    fill: "var(--vip-cta-color, #FF4A4A)"
  })));
}
export default SvgVipLocIcon;